import {IReg, REG} from "lib/commons/registry";

export interface IError {
	/**
	 * Résumé localisé de l'anomalie. Correspond à un titre (sans retour charriot).
	 */
	msg: string;

	/** Exception à l'origine l'erreur */
	cause?: Error;

	/** Contexte de l'erreur */
	ctx?: IErrorCtx;

	/**
	 * Message détaillé localisé pour l'utilisateur (avec retours charriot possibles).
	 */
	details?: string;

	/**
	 * Message non localisé et non affiché à l'utilisateur par défaut,
	 * destiné à l'envoi à un administrateur / développeur.
	 * Si non renseigné, il est déterminé à partir de la cause
	 * (analyse de la stack sur un RespError)
	 */

	/**
	 * Message non localisé et non affiché à l'utilisateur par défaut,
	 * destiné à l'envoi à un administrateur / développeur.
	 * Si non renseigné, il est déterminé à partir de la cause
	 * (ex: analyse de la trace Java sur un RespError)
	 */
	 adminDetails?: string;


	/**
	 * Version lisible de l'adminDetails (donc non localisé) non affiché
	 * à l'utilisateur par défaut.
	 * Peut retourner un élément HTML pour afficher correctement les niveaux d'erreur
	 * (classes supportées : .msgList, .warn, .error)
	 */
	technicalDetails?: string | HTMLElement;
}

export interface IErrorCtx {
	reg?: IReg<any>,
	[key: string]: any
}

export interface IErrorLog {
	logError(error: IError): void | Promise<void>;
}

const defaultErrorLog: IErrorLog = {
	logError(error: IError) {
		if (error.adminDetails) console.error(error.msg, error.adminDetails, error.cause);
		else console.error(error.msg, error.cause);

	}
};

REG.reg.registerSvc("errorLog", REG.LEVELAUTH_CORE, defaultErrorLog);
